import React, { FC } from "react";
import { Navigate } from "react-router-dom";

const ProbeView: FC = () => {
    return (
        <Navigate to={`test-runs`} />
    );
};

export default ProbeView;